var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"datepicker",staticClass:"date-picker",class:_vm.classNames,attrs:{"type":"text","name":_vm.name,"id":_vm.id}})}
var staticRenderFns = []

export { render, staticRenderFns }